/**
 * 权限检查工具
 * 用于在页面中根据权限控制按钮显示隐藏
 */

import {default as Vue} from "vue";

/**
 * 检查是否有指定权限
 * @param {String|Array} permission 权限标识，可以是字符串或数组（多个权限任一即可）
 * @param {Object} store Vuex store 实例，如果未传入则从全局获取
 * @returns {Boolean} 是否有权限
 */
export function hasPermission(permission, store = null) {
  console.log('pspspspspspspspspspsps', permission, store)
  // 如果没有传入store，尝试从全局获取
  if (!store) {
    try {
      const Vue = require('vue').default
      if (Vue && Vue.prototype && Vue.prototype.$store) {
        store = Vue.prototype.$store
      } else {
        console.warn('权限检查失败：无法获取store实例')
        return false
      }
    } catch (e) {
      console.warn('权限检查失败：', e)
      return false
    }
  }
  // 获取权限列表
  // 注意：menus 是一个 Vuex module，所以需要通过 store.state.menus 访问
  // store.state.menus 是 menus 模块的 state，包含：
  // - menuList: 菜单树数据
  // - permList: 权限标识数组（从菜单树的 permission 字段提取）
  // - hasRoute: 路由状态
  // - editableTabs: 标签页数据
  // - 等等...
  
  const permList = store.state.menus?.permList || []
  
  // 调试信息（可以移除）
  if (!permList || permList.length === 0) {
    console.warn('权限列表为空，可能的原因：1. 菜单还未加载 2. 菜单数据中没有 permission 字段')
    console.log('store.state.menus:', store.state.menus)
  }
  // 如果没有权限列表，返回false
  if (!Array.isArray(permList) || permList.length === 0) {
    return false
  }

  // 如果permission是数组，检查是否有任一权限
  if (Array.isArray(permission)) {
    return permission.some(perm => {
      if (!perm) return false
      return permList.includes(perm.trim())
    })
  }

  // 如果permission是字符串，直接检查
  if (typeof permission === 'string' && permission.trim()) {
    return permList.includes(permission.trim())
  }

  return false
}

/**
 * 检查是否有所有指定权限（需要同时拥有）
 * @param {Array} permissions 权限标识数组
 * @param {Object} store Vuex store 实例
 * @returns {Boolean} 是否拥有所有权限
 */
export function hasAllPermissions(permissions, store = null) {
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return false
  }

  if (!store) {
    try {
      const Vue = require('vue').default
      if (Vue && Vue.prototype && Vue.prototype.$store) {
        store = Vue.prototype.$store
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }

  const permList = store.state.menus?.permList || []
  
  if (!Array.isArray(permList) || permList.length === 0) {
    return false
  }

  return permissions.every(perm => {
    if (!perm) return false
    return permList.includes(perm.trim())
  })
}

